// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__3TyVx","inputText":"TextInput_inputText__1778r","error":"TextInput_error__3LARY"};